import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { getDeviceZoneVersionHistory, type EditDetectionZonePromiseParam } from 'src/utils/api';
import { useSearch } from 'src/hooks/use-search';
import { type ZoneTypeMap } from 'src/components/ZoneEditor/constants';

export const useGetDeviceZoneVersionHistory = () => {
  const [searchParams] = useSearch();
  const deviceId = searchParams?.device?.id || '';

  const { data, isLoading, error } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetDeviceZoneVersionHistory, deviceId],
    queryFn: () => getDeviceZoneVersionHistory(deviceId),
    enabled: !!deviceId,
  });

  return {
    data,
    isLoading,
    error,
  };
};

// id param here accepts version id or version zone id
export const useGetVersionObjectByZoneId = (id?: string, zoneType?: ZoneTypeMap) => {
  const { data: versionHistory } = useGetDeviceZoneVersionHistory();

  if (!versionHistory || !id || !zoneType) return undefined;

  return versionHistory?.[zoneType as keyof typeof versionHistory]?.find((version) => {
    const versionIdMatched = version?.id === id;

    if (versionIdMatched) return true;

    const parsedConfig = JSON.parse(version?.config || '{}') as EditDetectionZonePromiseParam;

    return Boolean(parsedConfig?.zones?.find((zone) => zone?.id === id));
  });
};
